import React from "react";
import { OrderData } from "../types/order";
import OrderDetailRow from "../common/OrderDetailRow";
import { ModalWrapper } from "src/shared/components/ModalWrapper";
import CommonButtons from "src/shared/components/CommonButtons";

interface CancelOrderDialogProps {
  open: boolean;
  onClose: () => void;
  order: OrderData;
  outstandingAmount: number;
  cancelData: string;
  onCancelDataChange: (value: string) => void;
  onConfirmCancel: () => void;
}

const CancelOrderDialog: React.FC<CancelOrderDialogProps> = ({ open, onClose, order, outstandingAmount, cancelData, onCancelDataChange, onConfirmCancel }) => {
  // Hooks and calculations first
  const receivedAmount = Number(order?.payments?.[0]?.ReceivedAmount || 0);
  const remainingAmount = Number(order?.RemainingAmount || 0);

  // useCallback MUST be called before any early return
  const refundAmount = React.useCallback(() => {
    if (outstandingAmount >= receivedAmount) return 0;
    return receivedAmount - outstandingAmount;
  }, [outstandingAmount, receivedAmount]);

  // Early return if modal closed
  if (!open) return null;

  const deductDetails = [
    { label: "Outstanding Balance", value: outstandingAmount },
    { label: "Current Order (OSB)", value: remainingAmount },
    { label: "Order cancel amount", value: receivedAmount },
    { label: "Excess Amount", value: refundAmount() },
  ];

  const isDeductDisabled = outstandingAmount === 0 || !deductDetails || deductDetails.length === 0 || deductDetails.every((d) => !d.value || d.value === 0);
  const refundOptions = [
    { label: "Refund", value: "refund", disabled: false },
    { label: "Deduct from Outstanding", value: "deduct_from_due", disabled: isDeductDisabled },
  ];

  return (
    <ModalWrapper title="Cancel Order" onClose={onClose} showCloseButton width="max-w-lg" useTheme>
      <p className="text-lg text-center">This action will cancel the order. Are you sure?</p>
      {receivedAmount > 0 && (
        // <Box mt={3} display="flex" flexDirection="column" alignItems="center">
        //   {/* Radio Options */}
        //   <Box display="flex" gap={4}>
        //     <FormControlLabel control={<Radio checked={cancelData === "refund"} onChange={() => onCancelDataChange("refund")} />} label="Refund" />
        //     <FormControlLabel
        //       control={<Radio checked={cancelData === "deduct_from_due"} onChange={() => onCancelDataChange("deduct_from_due")} disabled={outstandingAmount === 0} />}
        //       label="Deduct from Outstanding"
        //     />
        //   </Box>

        //   {/* Refund */}
        //   {cancelData === "refund" && (
        //     <Box mt={3} width="80%">
        //       <OrderDetailRow label="Received amount" value={receivedAmount} highlight />
        //     </Box>
        //   )}

        //   {/* Deduct from outstanding */}
        //   {cancelData === "deduct_from_due" && (
        //     <Box mt={3} width="80%" display="flex" flexDirection="column" gap={1.5}>
        //       <OrderDetailRow label="Outstanding Balance" value={outstandingAmount} />
        //       <OrderDetailRow label="Current Order (OSB)" value={remainingAmount} />
        //       <OrderDetailRow label="Order cancel amount" value={receivedAmount} />
        //       <OrderDetailRow label="Excess price" value={refundAmount()} highlight />
        //     </Box>
        //   )}
        // </Box>
        <div className="flex flex-col items-center justify-center h-full mt-4">
          <div className="flex flex-row items-center gap-4">
            {refundOptions.map((option) => (
              <div key={option.value} className={`flex items-center gap-2 ${option.disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}>
                <input
                  type="radio"
                  name="refundOption"
                  value={option.value}
                  checked={cancelData === option.value}
                  onChange={() => onCancelDataChange(option.value)}
                  className="w-6 h-6"
                  disabled={option.disabled}
                />
                <p>{option.label}</p>
              </div>
            ))}
          </div>

          {cancelData === "refund" && (
            <div className="flex mt-4 mr-4 font-semibold text-2xl w-fit gap-2 text-red-600">
              <span className="text-left">Received amount</span>
              <span className="text-center">:</span>
              <span>{receivedAmount} QAR</span>
            </div>
          )}

          {cancelData === "deduct_from_due" && (
            <div className="mt-4 space-y-2 font-semibold w-80">
              {deductDetails.map((item, index) => (
                <div key={index} className="flex justify-between w-full">
                  <span className="w-[65%] text-left">{item.label}</span>
                  <span className="w-[5%] text-center">:</span>
                  <span className="w-[40%] text-right">{item.value} QAR</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <div className="flex justify-end gap-4 mt-6">
        <CommonButtons className="w-36" label="Cancel" variant="outlineDanger" onClick={onClose} />
        <CommonButtons className="w-36" label="Confirm" onClick={onConfirmCancel} />
      </div>
    </ModalWrapper>
  );
};

export default CancelOrderDialog;
